import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0cc4a57c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "user-info" }
const _hoisted_3 = { class: "user-info-name" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "label" }, null, -1))
const _hoisted_5 = { style: {"flex-grow":"1"} }
const _hoisted_6 = {
  key: 0,
  class: "rights"
}
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "tips" }
const _hoisted_9 = { class: "rights-list" }
const _hoisted_10 = { class: "register" }
const _hoisted_11 = { class: "title" }
const _hoisted_12 = { class: "register-content" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "rate" }, "3.88%", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Successfully registered Tesla owners", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("can enjoy an unsecured loan with a fixed APR of"),
  /*#__PURE__*/_createElementVNode("span", { class: "rate" }, "3.88%")
], -1))
const _hoisted_16 = { class: "order" }
const _hoisted_17 = { class: "title" }
const _hoisted_18 = { class: "order-content" }
const _hoisted_19 = {
  key: 0,
  class: "register"
}
const _hoisted_20 = { class: "title" }
const _hoisted_21 = { class: "register-content register-content-other" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "rate" }, "HKD 500", -1))
const _hoisted_23 = { class: "order" }
const _hoisted_24 = { class: "title" }
const _hoisted_25 = { class: "order-content order-content-other" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "rate" }, "HKD 200", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "detail-divide" }, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "detail-divide" }, null, -1))

import { onBeforeMount, onMounted, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { SortList } from './components';
import LangVue from '@common/components/lang.vue';
import { TIcon } from '@tencent/web-vbui';
import { spin } from '@tencent/web-vbui/src/components/t-spin/spin';
import { navigator } from '@tencent/vb-app-bridge';
import { i18n, reportStatistics } from '@tencent/vb-web-base';
import { to } from '@tencent/vb-web-base-core';
import Contract from '@tencent/vb-web-contract';
import { baseMixins } from '@common/mixins/baseMixins';
import { getUmUserInfo } from '@common/core/network/umAPI';
import { CheckNoTeslaWhiteAndIsElectricCar, GetRightList } from '@common/core/network/activityAPI';
import { IRightConfig, IRightItem, IRightSortConfig } from '@common/core/interface/IModel';
import { useGlobalState } from '../../store/carOwnerRight';


export default /*#__PURE__*/_defineComponent({
  __name: 'RightMy',
  setup(__props) {

const router = useRouter();
const route = useRoute();

const { loanAmount: loanAmt, overdue, prepay, writeOff, brand, isElectricCar } = route.query;
const isElectricCarLabel = ref('');
isElectricCarLabel.value = isElectricCar as string;
const state = useGlobalState();
const { getT } = i18n;
// i18n.setLang('en-GB');
const $t = getT();
const { setTitle, showModalError, showModal, isEng, formatWithCommas } = baseMixins();
const title = brand === 'tesla' ? $t('Tesla车主尊尚礼遇') : $t('富融车主会');
setTitle(title);

const goRightsOverviewPage = () => {
  router.push({
    path: brand === 'tesla' ? '/teslaRightOverview' : '/otherRightOverview',
    query: {
      from: 'rightMy',
    },
  });
};
const goRightsEntrancePage = () => {
  router.push('/carOwnerRightEntrance');
};
// 活动权益列表
let rightList: IRightItem[] = [];
const curSorts = ref<IRightSortConfig[]>([]);
const getRightList = async () => {
  if (brand === 'tesla' ? state.value.allTeslaRightList?.length : state.value.allOtherRightList?.length) {
    rightList = brand === 'tesla' ? state.value.allTeslaRightList : state.value.allOtherRightList;
  } else {
    const [data, err] = await to(GetRightList(brand as string));
    if (err) {
      showModalError(err.message, err.code);
      return;
    }
    if (brand === 'tesla') {
      state.value.allTeslaRightList = data;
    } else {
      state.value.allOtherRightList = data;
    }
    rightList = data;
  }
};
const getUserRank = () => {
  const rightItem = rightList.find((item) => {
    const amt = Number(loanAmt);
    if (item.isIncludeFloor === '0' && item.isIncludeUpper === '1') {
      return Number(item.limitFloor) <= amt && Number(item.limitUpper) > amt;
    }
    if (item.isIncludeFloor === '0' && item.isIncludeUpper === '0') {
      return Number(item.limitFloor) <= amt && Number(item.limitUpper) >= amt;
    }
    if (item.isIncludeFloor === '1' && item.isIncludeUpper === '0') {
      return Number(item.limitFloor) < amt && Number(item.limitUpper) >= amt;
    }
    return Number(item.limitFloor) < amt && Number(item.limitUpper) > amt;
  });
  if (rightItem) {
    curSorts.value = rightItem.sorts;
    state.value.curRights = rightItem.sorts.reduce((prev: IRightConfig[], cur) => prev.concat(cur.rights || []).concat(cur.chooseRights || []), []);
  }
};
const userName = ref('');
const getUserName = async () => {
  const [data, err] = await to(getUmUserInfo());
  if (err) {
    showModalError(err.message, err.code);
  }
  userName.value = isEng.value ? data.enName : data?.name;
};
const setUserState = () => {
  if (overdue === '0' || writeOff === '0') {
    return {
      text: $t('由于您曾有贷款逾期记录，剩余礼遇已不能领取'),
      state: 'disabled',
    };
  }
  if (prepay === '0') {
    return {
      text: $t('由于您已提前结清贷款，剩余礼遇已不能领取'),
      state: 'disabled',
    };
  }
  const loanAmount = formatWithCommas(loanAmt as string);
  return {
    text: $t('已提取HKD{loanAmount}', { loanAmount }),
    state: 'normal',
  };
};
const userState = setUserState();
const showTipsModal = () => {
  if (overdue === '0' || writeOff === '0') {
    showModal($t('您已出现贷款逾期记录，无法领取剩余礼遇'), '', '', $t('我知道了'));
    return false;
  }
  if (prepay === '0') {
    showModal($t('您已提前结清贷款，无法领取剩余礼遇'), '', '', $t('我知道了'));
    return false;
  }
  return true;
};

const checkIsElectricCar = async () => {
  const [data, err] = await to(CheckNoTeslaWhiteAndIsElectricCar());
  if (err) {
    showModalError(err.message, err.code);
    // return;
  }
  isElectricCarLabel.value = data.isElectricCar ? '0' : '1';
};

const goOrderPage = () => {
  router.push('/teslaOrder');
};
const goRecordListPage = () => {
  router.push('/recordList');
};

// 查看协议
const checkProto = () => {
  const contract = new Contract({
    key: brand === 'tesla' ? 'TeslaOwnerRight' : 'CarOwnerRight',
    autoSign: false,
    containerType: 'dialog',
    needAgree: false,
    needCheckBox: false,
    hideBtn: true,
    needTitle: false,
  });
  contract.preview();
};
const goMerchantInfoPage = () => {
  router.push('/rightMerchant');
};
const goCouponPage = () => {
  navigator.push({
    path: '/e/my/coupon.html',
  });
};
onBeforeMount(async () => {
  spin.show();
  await getRightList();
  spin.hide();
  if (!isElectricCarLabel.value && brand === 'other') {
    checkIsElectricCar();
  }
  getUserRank();
  getUserName();
});
onMounted(() => {
  reportStatistics({
    evtName: `${brand}rightMy`,
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["user", { 'user-other': _unref(brand) === 'other' }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(userName.value), 1),
        _createElementVNode("div", {
          class: _normalizeClass(["user-info-state", { 'user-info-state_disabled': _unref(userState).state === 'disabled' }])
        }, [
          _hoisted_4,
          _createTextVNode(_toDisplayString(_unref(userState).text), 1)
        ], 2)
      ]),
      _createElementVNode("div", {
        class: "user-rights",
        onClick: goRightsEntrancePage
      }, [
        _createElementVNode("a", null, _toDisplayString(_unref($t)('更多车主权益')), 1),
        _createVNode(_unref(TIcon), {
          "icon-name": "more",
          opacity: 0.5,
          size: "small"
        }, null, 8, ["opacity"])
      ])
    ], 2),
    _createElementVNode("div", _hoisted_5, [
      (curSorts.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("h3", _hoisted_7, [
              _createElementVNode("span", null, _toDisplayString(_unref(brand) === 'tesla' ? _unref($t)('我的专享礼遇') : _unref($t)('我的「车生活」礼遇')), 1),
              _createElementVNode("a", { onClick: goRecordListPage }, _toDisplayString(_unref($t)('领取记录')), 1)
            ]),
            _createElementVNode("p", _hoisted_8, _toDisplayString(_unref($t)('每种权益每月可选一次')), 1),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_unref(SortList), {
                sorts: curSorts.value,
                beforeJump: showTipsModal,
                action: "link"
              }, null, 8, ["sorts"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(brand) === 'tesla')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("h3", _hoisted_11, _toDisplayString(_unref($t)('登记即有奖赏')), 1),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(LangVue, null, {
                  default: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(_unref($t)('成功登记为Tesla车主，')), 1),
                    _createElementVNode("p", null, [
                      _createTextVNode(_toDisplayString(_unref($t)('享无抵押贷款一口价')), 1),
                      _hoisted_13,
                      _createTextVNode(_toDisplayString(_unref($t)('实际年利率')), 1)
                    ])
                  ]),
                  en: _withCtx(() => [
                    _hoisted_14,
                    _hoisted_15
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("h3", _hoisted_17, _toDisplayString(_unref($t)('Tesla特快通道试驾服务')), 1),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("p", null, _toDisplayString(_unref($t)('Fusion Bank用户专享')), 1),
                _createElementVNode("div", {
                  class: "link",
                  onClick: goOrderPage
                }, [
                  _createElementVNode("a", null, _toDisplayString(_unref($t)('预约方法')), 1),
                  _createVNode(_unref(TIcon), {
                    "icon-name": "more",
                    theme: "link",
                    size: "small"
                  })
                ])
              ])
            ])
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (isElectricCarLabel.value === '0')
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("h3", _hoisted_20, _toDisplayString(_unref($t)('绿色特别赏')), 1),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("p", null, [
                      _hoisted_22,
                      _createTextVNode(_toDisplayString(_unref($t)('已发放到您的富融银行账户，请注意查收')), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("h3", _hoisted_24, _toDisplayString(_unref($t)('会员奖赏')), 1),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", null, [
                  _createElementVNode("p", null, [
                    _hoisted_26,
                    _createTextVNode(" " + _toDisplayString(_unref($t)('和贷款优惠券已发放到您的富融银行账户及优惠中心，请注意查收。')), 1)
                  ])
                ]),
                _createElementVNode("div", {
                  class: "link",
                  onClick: goCouponPage
                }, [
                  _createVNode(_unref(TIcon), {
                    "icon-name": "more",
                    theme: "link",
                    size: "small"
                  })
                ])
              ])
            ])
          ], 64))
    ]),
    _createElementVNode("p", {
      class: _normalizeClass(["detail", { eng: _unref(isEng) }])
    }, [
      _createElementVNode("span", {
        class: "detail-item",
        onClick: checkProto
      }, _toDisplayString(_unref($t)('条款及细则')), 1),
      _hoisted_27,
      _createElementVNode("span", {
        class: "detail-item",
        onClick: goMerchantInfoPage
      }, _toDisplayString(_unref($t)('礼遇合作商户信息')), 1),
      _hoisted_28,
      _createElementVNode("span", {
        class: "detail-item",
        onClick: goRightsOverviewPage
      }, _toDisplayString(_unref($t)('关于专属权益')), 1)
    ], 2)
  ]))
}
}

})